import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useWhatsapp } from '@/hooks/useWhatsapp';

import OAuthCard from './OAuthCard';
import Settings from './Settings';
import WhatsappSkeleton from './WhatsappSkeleton';

const Whatsapp = () => {
  const { t } = useTranslation();
  const {
    integration,
    connectionStatus,
    onOAuthClick,
    isConnecting,
    isLoading,
    phoneChangeInfo,
    onConfirmPhoneChange,
    onCancelPhoneChange,
    conflict,
    pin,
    setPin,
  } = useWhatsapp();

  if (!integration) {
    return null;
  }

  if (isLoading) {
    return <WhatsappSkeleton />;
  }

  // If the integration is connected, show the settings page
  if (connectionStatus === 'connected') {
    return (
      <>
        <Settings />
        <AlertDialog open={!!phoneChangeInfo} onOpenChange={() => onCancelPhoneChange()}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{t('integrations.whatsapp.phone_change.title')}</AlertDialogTitle>
              <AlertDialogDescription>
                {t('integrations.whatsapp.phone_change.description', {
                  0: phoneChangeInfo?.previousPhone,
                  1: phoneChangeInfo?.newPhone,
                })}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
              <AlertDialogAction onClick={onConfirmPhoneChange}>
                {t('common.confirm')}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </>
    );
  }

  return (
    <OAuthCard
      onOAuthClick={onOAuthClick}
      isConnecting={isConnecting}
      conflict={conflict}
      pin={pin}
      onPinChange={setPin}
    />
  );
};

export default Whatsapp;
